import { render, staticRenderFns } from "./data-result.vue?vue&type=template&id=3ce853be&scoped=true&"
import script from "./data-result.vue?vue&type=script&lang=ts&"
export * from "./data-result.vue?vue&type=script&lang=ts&"
import style0 from "./data-result.vue?vue&type=style&index=0&id=3ce853be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce853be",
  null
  
)

export default component.exports